<script setup>
import { ref, defineProps } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';

import 'swiper/css';
import 'swiper/css/pagination';

defineProps({
    photos: {
        type: Array,
        default: () => []
    }
});

const swiperInstance = ref(null);
const activeIndex = ref(0);

const onSwiper = (swiper) => {
    swiperInstance.value = swiper;

};

const onSlideChange = (swiper) => {
    activeIndex.value = swiper.activeIndex;
};

const goToSlide = (index) => {
    if (swiperInstance.value) {
        swiperInstance.value.slideTo(index);
    }
};
</script>

<template>
    <div class="pets-photo-slider">
        <Swiper
            :slides-per-view="1"
            :speed="750"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
        >
            <SwiperSlide
                v-for="(photo, idx) in photos"
                :key="idx"
            >
                <div class="pets-photo-slider__item">
                    <img :src="`https://www.friendforpet.ru${photo}`" alt="">
                </div>
            </SwiperSlide>
        </Swiper>
        <div class="pets-photo-slider__pagination">
            <div class="pets-photo-slider__pagination-inner">
                <div
                    v-for="(bullet, idx) in photos"
                    :key="idx"
                    class="pets-photo-slider__pagination-bullet"
                    :class="{ '_active': idx === activeIndex }"
                    @click="goToSlide(idx)"
                    @mouseenter="goToSlide(idx)"
                />
            </div>
        </div>
    </div>
</template>
